export enum PlatformType {
  tag = 'TAG',
  fs = 'FS',
  both = 'BOTH',
}

export type PlatformData = {
  type?: PlatformType;
  tagUrl?: string;
  fsUrl?: string;
};
